var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTitlesOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878793;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.51,11.78l-1-1-1,1a.65.65,0,0,1-.91-.93l1-1-1-1s0-.07-.08-.11L4.21,7.45a4.1,4.1,0,0,0-.83,2.44A4.15,4.15,0,0,0,7.51,14,4.05,4.05,0,0,0,10,13.19L8.63,11.86A.32.32,0,0,1,8.51,11.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,9l1-1a.64.64,0,0,1,.91.91l-1,1,1,1,.06.09c.46.46.91.91,1.36,1.34a4.06,4.06,0,0,0,.81-2.44A4.15,4.15,0,0,0,7.51,5.77a4.08,4.08,0,0,0-2.41.8L6.66,8.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.37,11H13.48a.88.88,0,1,0,0,1.76h5.89a.88.88,0,1,0,0-1.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.25,16.5a.87.87,0,0,0-.88-.88H14.2l.47.46L16,17.39h3.38A.88.88,0,0,0,20.25,16.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,8.7h5.89a.89.89,0,0,0,0-1.77H13.48a.89.89,0,0,0,0,1.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.27,15.62a.89.89,0,1,0,0,1.77h9.89l-1.77-1.77Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.25,3.84,3.14,3c3.33,3.32,7.28,7.56,10.46,10.46l1,1c.07.09.85.86,1.11,1.11L21,20.75l.07.06-.9.9Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTitlesOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-titles-off.c46dbb50bdc3451ee48db7bf4311535d.svg";